export default "__VITE_ASSET__ByR4VEFN__"